// src/pages/ActivityPage.jsx
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import './ActivityPage.css';

const ActivityPage = () => {
  const { userId } = useParams();
  const [user, setUser] = useState(null);
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchLogs = async () => {
      try {
        const res = await fetch(`https://ccjab.pro/api/activity.php/${userId}`);
        const data = await res.json();
        setUser(data.user);
        setLogs(data.logs);
      } catch (err) {
        console.error('Erreur lors de la récupération des activités :', err);
        setLogs([]);
      } finally {
        setLoading(false);
      }
    };

    fetchLogs();
  }, [userId]);

  return (
    <div className="activity-page">
      {user && (
        <div className="user-profile-box">
          <img
            src={user.profile_photo ? `https://ccjab.pro/uploads/${user.profile_photo}` : 'https://via.placeholder.com/100'}
            alt="Photo de profil"
            className="profile-photo"
          />

          <div className="user-info">
            <h2>{user.username}</h2>
            <p className="user-email">{user.email}</p>
            <span className={`role-badge ${user.role}`}>{user.role}</span>
          </div>
        </div>
      )}

      <h3 className="section-title">Historique des activités</h3>

      {loading ? (
        <p>Chargement des activités...</p>
      ) : logs.length === 0 ? (
        <p>Aucune activité enregistrée pour ce membre.</p>
      ) : (
        <ul className="activity-list">
          {logs.map((log, index) => (
            <li key={index} className="activity-item">
              <span className="activity-date">
                Le {new Date(log.date).toLocaleDateString('fr-FR', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })} à {new Date(log.date).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}
              </span>
              <span className={`activity-action ${log.action}`}>{log.action}</span>
              <span className="activity-title">
                {log.action === 'création' ? `a créé l'évènement "${log.titre}"` : `a supprimé l'évènement "${log.titre}"`}
              </span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default ActivityPage;